export default __webpack_public_path__ + "static/media/trophy.0b6ddde9.svg";